import { AiFillCaretDown, AiFillCaretRight, AiOutlineMenu } from "react-icons/ai";
import Button from "../Button/Button";
import logo from "../../assets/oq-logo-1.svg";
import logoWhite from "../../assets/oq-logo-1-white.svg";
import { ImCross } from "react-icons/im";
import "./NavBar.scss";
import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import PRODUCTS from "../../pages/SignUpPage/products";
import { ESSAY_PRIZE_NAV_ITEMS } from "../../pages/NationalEssayPrizesPage/essayPrizes";

const NavBar = () => {
  const [productsMenuOpen, setProductsMenuOpen] = useState(false);
  const [essayPrizesMenuOpen, setEssayPrizesMenuOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isMobileNav = () => window.innerWidth <= 850;

  const closeAllDropdowns = () => {
    setProductsMenuOpen(false);
    setEssayPrizesMenuOpen(false);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    closeAllDropdowns();
  };

  // Close mobile menu and dropdowns when route changes
  useEffect(() => {
    closeMobileMenu();
  }, [location.pathname]);

  // Close mobile menu when resizing to desktop width
  useEffect(() => {
    const handleResize = () => {
      if (!isMobileNav() && mobileMenuOpen) {
        closeMobileMenu();
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [mobileMenuOpen]);

  const menuOpenButtonClicked = () => {
    closeAllDropdowns();
    setMobileMenuOpen(true);
  };

  const menuCloseButtonClicked = () => {
    closeMobileMenu();
  };

  const closeMobileMenuIfOpen = () => {
    if (mobileMenuOpen) {
      closeMobileMenu();
    } else {
      closeAllDropdowns();
    }
  };

  const handleProductClick = () => {
    closeMobileMenu();
  };

  const handleEssayPrizeClick = () => {
    closeMobileMenu();
  };

  const productsMenuClicked = (e: React.MouseEvent) => {
    e.preventDefault();
    if (isMobileNav()) {
      const willOpen = !productsMenuOpen;
      setProductsMenuOpen(willOpen);
      setEssayPrizesMenuOpen(false);
    }
  };

  const handleProductsMouseEnter = () => {
    if (!isMobileNav()) {
      setProductsMenuOpen(true);
    }
  };

  const handleProductsMouseLeave = () => {
    if (!isMobileNav()) {
      setProductsMenuOpen(false);
    }
  };

  const essayPrizesMenuClicked = (e: React.MouseEvent) => {
    e.preventDefault();
    if (isMobileNav()) {
      const willOpen = !essayPrizesMenuOpen;
      setEssayPrizesMenuOpen(willOpen);
      setProductsMenuOpen(false);
    }
  };

  const handleEssayPrizesMouseEnter = () => {
    if (!isMobileNav()) {
      setEssayPrizesMenuOpen(true);
    }
  };

  const handleEssayPrizesMouseLeave = () => {
    if (!isMobileNav()) {
      setEssayPrizesMenuOpen(false);
    }
  };

  const handleTopLevelNavClick = () => {
    closeMobileMenuIfOpen();
  };

  // const subMenu1Clicked = (e: any) => {
  //     navLinks.classList.toggle("show1");
  // }

  // const subSubMenu1Clicked = (e: any) => {
  //     navLinks.classList.toggle("show2");
  // }

  // const subMenu2Clicked = (e: any) => {
  //     navLinks.classList.toggle("show3");
  // }

  return (
    <div id="NavBar">
      <nav>
        <div className="navbar">
          <button
            type="button"
            className="bx bx-menu mobile-menu-toggle"
            onClick={menuOpenButtonClicked}
            aria-label="Open menu"
            aria-expanded={mobileMenuOpen}
          >
            <AiOutlineMenu height={"20px"} />
          </button>
          {mobileMenuOpen && (
            <button
              type="button"
              className="mobile-menu-backdrop"
              aria-label="Close menu"
              onClick={menuCloseButtonClicked}
            />
          )}
          <div className="logo">
            <Link to={"/"}>
              <img src={logo} alt="OphthalmologyQ" className="navbar-logo" />
            </Link>
          </div>
          <div className={`nav-links${mobileMenuOpen ? " mobile-open" : ""}${productsMenuOpen ? " show-products" : ""}${essayPrizesMenuOpen ? " show-essay-prizes" : ""}`}>
            <div className="sidebar-logo">
              {/* <span className="logo-name">CodingLab</span> */}
              <img src={logoWhite} alt="logo" className="logo-name" />
              <button
                type="button"
                className="mobile-menu-close"
                onClick={menuCloseButtonClicked}
                aria-label="Close menu"
              >
                <ImCross className="bx bx-x" color="white" />
              </button>
            </div>
            <ul className="links">
              <li className="nav-top-level-item">
                <Link to="/about" onClick={handleTopLevelNavClick}>
                  About
                </Link>
              </li>
              <li className={`products-menu-item${productsMenuOpen ? " is-open" : ""}`}>
                <button
                  type="button"
                  onClick={productsMenuClicked}
                  onMouseEnter={handleProductsMouseEnter}
                  onMouseLeave={handleProductsMouseLeave}
                  className="products-menu-link"
                  aria-expanded={productsMenuOpen}
                >
                  Resources
                  <AiFillCaretDown className={`bx bxs-chevron-down products-menu-arrow products-menu-arrow-down arrow ${productsMenuOpen ? 'show' : ''}`}/>
                  <AiFillCaretRight className={`bx bxs-chevron-right products-menu-arrow products-menu-arrow-right arrow ${productsMenuOpen ? '' : 'show'}`}/>
                </button>
                <ul className={`products-sub-menu sub-menu ${productsMenuOpen ? 'show' : ''}`}>
                  {PRODUCTS.filter(p => !p.comingSoon || p.id === "portfolio_builder" || p.id === "interview_coaching").map(product => (
                    <li key={product.id}>
                      <Link to={`/products/${product.id}`} onClick={handleProductClick} className="nav-product-link">
                        <span className="nav-product-link-text">{product.title}{product.price > 0 ? ` (£${product.price})` : ''}</span>
                        {product.id === 'interview_coaching' && (
                          <span className="nav-product-pill nav-product-pill-limited">Limited spaces</span>
                        )}
                        {product.comingSoon && (
                          <span className="nav-product-pill nav-product-pill-coming-soon">coming soon</span>
                        )}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
              <li className={`essay-prizes-menu-item${essayPrizesMenuOpen ? " is-open" : ""}`}>
                <button
                  type="button"
                  onClick={essayPrizesMenuClicked}
                  onMouseEnter={handleEssayPrizesMouseEnter}
                  onMouseLeave={handleEssayPrizesMouseLeave}
                  className="essay-prizes-menu-link"
                  aria-expanded={essayPrizesMenuOpen}
                >
                  National Essay Prizes
                  <AiFillCaretDown
                    className={`bx bxs-chevron-down essay-prizes-menu-arrow essay-prizes-menu-arrow-down arrow ${essayPrizesMenuOpen ? "show" : ""}`}
                  />
                  <AiFillCaretRight
                    className={`bx bxs-chevron-right essay-prizes-menu-arrow essay-prizes-menu-arrow-right arrow ${essayPrizesMenuOpen ? "" : "show"}`}
                  />
                </button>
                <ul className={`essay-prizes-sub-menu sub-menu ${essayPrizesMenuOpen ? "show" : ""}`}>
                  {ESSAY_PRIZE_NAV_ITEMS.map((item) => (
                    <li key={item.path}>
                      <Link to={item.path} onClick={handleEssayPrizeClick}>
                        {item.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
              <li className="nav-top-level-item">
                <Link to="/testimonials" onClick={handleTopLevelNavClick}>
                  Testimonials
                </Link>
              </li>
              {/* <li>
                <Link to={window.location.origin + '/#newsletter'} onClick={closeMobileMenuIfOpen}>Newsletter</Link>
              </li> */}
              <li className="nav-top-level-item hideInDesktopView">
                <Link to={"/sign-up"} onClick={handleTopLevelNavClick}>
                  Sign Up
                </Link>
              </li>
              <li className="nav-top-level-item hideInDesktopView nav-top-level-item--button">
                <div className="Button">
                  <Link to="/login" onClick={handleTopLevelNavClick}>
                    Login
                  </Link>
                </div>
              </li>
              {/* <li>
                  <a onClick={subMenu1Clicked}>HTML & CSS</a>
                  <AiFillCaretDown className='bx bxs-chevron-down submenu-1-arrow arrow'/>
                  <ul className="htmlCss-sub-menu sub-menu">
                      <li><a>Web Design</a></li>
                      <li><a>Login Forms</a></li>
                      <li><a>Card Design</a></li>
                      <li className="more">
                          <span><a onClick={subSubMenu1Clicked}>More</a>
                              <AiFillCaretRight className='bx bxs-chevron-right arrow sub-submenu-1-arrow'/>
                          </span>
                          <ul className="more-sub-menu sub-menu">
                              <li><a>Neumorphism</a></li>
                              <li><a>Pre-loader</a></li>
                              <li><a>Glassmorphism</a></li>
                          </ul>
                      </li>
                  </ul>
              </li>
              <li>
                  <a onClick={subMenu2Clicked}>JAVASCRIPT</a>
                  <AiFillCaretDown className='bx bxs-chevron-down submenu-2-arrow arrow'/>
                  <ul className="js-sub-menu sub-menu">
                      <li><a>Dynamic Clock</a></li>
                      <li><a>Form Validation</a></li>
                      <li><a>Card Slider</a></li>
                      <li><a>Complete Website</a></li>
                  </ul>
              </li> */}
            </ul>
          </div>
          <ul className="search-box">
            <li>
              <Link to={"/sign-up"}>Sign Up</Link>
            </li>
            {/* <li>
              <Link to={"/contact-us"}>Contact us</Link>
            </li> */}
            <Button text="Login" linkTo="/login" />
            {/* <i className='bx bx-search'></i>
              <div className="input-box">
                  <input type="text" placeholder="Search..."/>
              </div> */}
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default NavBar;
